import config from '@/config';
import { LogicContext } from '@/logic/main/types';
import { postData } from '@/model/utils/fetch';

export const fetchRefreshedAuthToken = (
  context: LogicContext
) => async (): Promise<any> => {
  try {
    const refreshToken = context.user.authToken?.refresh_token;
    const response = await postData<any>({
      url: `${config.urls.bffBaseUrl}/refresh_token`,
      body: { refresh_token: `${refreshToken}` },
    });
    return response || {};
  } catch (e) {
    console.error(e);
    return {};
  }
};
